import window from '@/utils/window';

/**
 * Appends the current `window.location.hash` (e.g. `#tab=directory`) to a URL that is
 * about to be pushed/replaced onto the history stack, so an active tab (or any other
 * hash-driven UI state) is not lost when a tab-nested feature updates its own URL
 * search params (filters, sort, search terms, pagination, etc).
 *
 * Fixes AHSMKTG-4189 (generalizes the one-off fix from AHSMKTG-4107 in DirectoryContext).
 *
 * Accepts either a plain path+search string (e.g. `/content/ahs/page?sort=name`) or a
 * react-router `history.push`/`history.replace` location object (`{ pathname, search }`),
 * matching the two call shapes used across the search/filter contexts.
 *
 * @param {string|{pathname: string, search: string, hash?: string}} url - The destination
 *   to preserve the hash on.
 * @returns {string|Object} The same shape as `url`, with the current page hash appended,
 *   unless the destination already carries its own hash or there is no hash to preserve.
 */
export const preserveHashInUrl = (url) => {
    const hash = window.location.hash;

    if (!hash) {
        return url;
    }

    if (typeof url === 'string') {
        return url.includes('#') ? url : `${url}${hash}`;
    }

    if (url && typeof url === 'object' && !url.hash) {
        return { ...url, hash };
    }

    return url;
};

export default preserveHashInUrl;
